<ng-container *transloco="let t;">

    <div class="uploaded-files-list" [formGroup]="form">
        <div class="d-flex justify-content-start align-items-center columngap w-100">
            <div class="d-block w-100">
                <div class="d-flex">
                    <div class="uploaded-files-listing">
                        <div class="file-icon">
                            <i data-feather="file-text" size="16" class=""></i>
                        </div>
                        <div class="upload-files-info">
                            <h4 class="uploaded-file-name">{{ file?.name }}</h4>
                            <div class="uploaded-file-progressbar">
                                <ngb-progressbar type="success" [value]="progress"></ngb-progressbar>
                            </div>
                            <div class="uploaded-file-size-percent">
                                <span>{{ progress }}%</span>
                                <span class="file-size">{{ file?.size | fileSize }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="file-delete-icon justify-content-end d-flex" (click)="onDelete()">
                        <i data-feather="trash-2" class="cursor-pointer" size="16"></i>
                    </div>
                </div>
                <div *ngIf="form && form.get('file').errors"
                     class="invalid-feedback d-block file-validation-field">
                    <div *ngIf="form.get('file').errors.maxSize">
                        {{ form.get('file').errors?.maxSize?.message }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row m-0 mt-1 w-100 bulkUpload-rightColumn-border">
            <div class="col-12 form-group mb-0 ps-0 pe-75">
                <label class="col-form-label p-0 mb-50">
                    {{ t('Document type label (general) - Document type') }}
                </label>
                <ng-select
                      #SelectSizeDefault
                      [items]="documentTypes"
                      [searchable]="false"
                      formControlName="document_type_id"
                      bindLabel="document_type"
                      bindValue="id"
                      class="ng-select-modal-dropdown-panel bulk-upload-select"
                      [placeholder]="t('Document type label (general) - Document type')"
                      (change)="onDocumentTypeChange($event)"
                    >
                      <ng-template ng-header-tmp>
                        <input
                          class="form-control w-100"
                          type="text"
                          (input)="SelectSizeDefault.filter($event.target.value)"
                        />
                      </ng-template>
                </ng-select>

                <div *ngIf="form && form.get('document_type_id').errors"
                     class="invalid-feedback d-block">
                    <div *ngIf="form.get('document_type_id').errors.required">
                        {{t('Field required (form validation) - Field name is required',{
                        fieldName: t('Document type label (general) - Document type')}) }}
                    </div>
                </div>

            </div>
            <div class="col-6 form-group mb-0 ps-75 pe-0">
                <div class="category-cascaders-container">
                    @for (field of categoryFields; track field.category.id) {
                        <app-cascader-select 
                            [categories]="[field.category]"
                            [selectedIds]="getCategoryControlValue(field)"
                            [label]="field.category.category_name"
                            [customClass]="'bulk-upload-cascader'"
                            (save)="handleCategoryFieldChange($event, field)"
                        ></app-cascader-select>
                    }
                </div>

                <div *ngIf="form && form.get('category_ids').errors"
                     class="invalid-feedback d-block">
                    <div *ngIf="form.get('category_ids').errors.required">
                        {{t('Field required (form validation) - Field name is required',{
                        fieldName: t('Category label (Document right menu) - Category')})}}
                    </div>
                </div>

            </div>
        </div>
    </div>

</ng-container>
